/* src/app/component/page/page.component.css */
/*# sourceMappingURL=page.component.css.map */
